@if (CompanyVendor && Vendor) {
  <div class="container-fluid">
    <div class="page-head">
      <h2 class="page-title">Ratings {{ ' - ' + Vendor.legalName }}</h2>
      <div class="action-row">
        <button class="btn btn-primary" (click)="addUpdateReview()">
          {{ yourVendorRating ? 'Edit your' : 'Add a' }} review
        </button>
      </div>
    </div>
    <div class="row justify-content-center mt-3">
      <div class="col-12 col-lg-5 col-xl-4">
        <app-display-card
          [header]="'Overall Vendor Rating'"
          [panelHeight]="'fit'"
        >
          <div class="inner-panel rounded">
            <div class="row justify-content-center">
              <div class="col">
                <app-star-rating
                  [rating]="overallVendorRating"
                  [size]="32"
                  [readonly]="true"
                ></app-star-rating>
                <div class="text-center fs-24">
                  <span class="fw-semibold">
                    <span
                      [ngClass]="{
                        'success-green': overallVendorRating! >= 4,
                        orange: overallVendorRating! < 4
                      }"
                    >
                      {{
                        overallVendorRating % 1 === 0
                          ? (overallVendorRating | number: '1.0-0')
                          : (overallVendorRating | number: '1.1-1') || 0
                      }} </span
                    >/5 </span
                  >Stars
                </div>
                <div class="text-center">
                  Based on
                  <span class="text-decoration-underline fw-semibold">{{
                    VendorReviews.length
                  }}</span>
                  Review(s)
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>
    <div class="row g-3 my-4">
      <div class="col-12 col-xxl-7">
        <app-display-card [panelHeight]="'fit'">
          <h3 class="text-center">
            {{
              !currentVendorRating
                ? 'No Reviews Yet!'
                : currentVendorRating.User?.firstName +
                  ' ' +
                  currentVendorRating.User?.lastName +
                  "'s Review Details"
            }}
          </h3>
          <div class="inner-panel rounded">
            <app-vendor-review-questions
              [VendorReview]="currentVendorRating"
              [readOnly]="true"
              [showOverallRatings]="true"
            ></app-vendor-review-questions>
          </div>
        </app-display-card>
      </div>
      <div class="col">
        <app-display-card
          [header]="'Users Who Have Reviewed This Vendor'"
          [panelHeight]="'fit'"
        >
          <div class="container-fluid p-0">
            <div class="row g-3">
              <div class="col">
                <div class="inner-panel rounded h-100">
                  <div class="row">
                    <div class="col-4">
                      <p class="fw-semibold text-start">User's Name</p>
                    </div>
                    <div class="col-4">
                      <p class="fw-semibold text-center">Rating</p>
                    </div>
                    <div class="col-4">
                      <p class="fw-semibold text-end">Review Date</p>
                    </div>
                  </div>
                  @for (
                    review of VendorReviews;
                    track review;
                    let last = $last
                  ) {
                    <div
                      class="user-row row text-center justify-content-center align-items-center py-1 px-3"
                      (click)="changeCurrentVendorReview(review)"
                    >
                      <div class="col-4">
                        <p class="m-0 text-start">
                          {{
                            review.User?.firstName + ' ' + review.User?.lastName
                          }}
                        </p>
                      </div>
                      <div class="col-4">
                        <app-star-rating
                          [rating]="review.overallVendorRating!"
                          [size]="14"
                        ></app-star-rating>
                      </div>
                      <div class="col-4">
                        <p class="m-0 text-end">
                          {{ review.updatedAt | date: 'MM/dd/y' }}
                        </p>
                      </div>
                    </div>
                    @if (!last) {
                      <hr class="my-2" />
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>
  </div>
}
